export const LOADING = "LOADING";
export const LOADED = "LOADED";
export const ERROR = "ERROR";
export const CLEAR_NOTIFICATION = " CLEAR_NOTIFICATION";
